import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const FrameContainer = t0 => {
  const $ = _c(8);
  const {
    children,
    className: t1,
    noMobilePadding: t2,
    noPadding: t3,
    wide: t4
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const noMobilePadding = t2 === undefined ? false : t2;
  const noPadding = t3 === undefined ? false : t3;
  const wide = t4 === undefined ? false : t4;
  const t5 = `mx-auto my-0 px-5 py-8 md:border md:border-solid md:border-gray-light7 md:mb-[55px] md:mt-12 md:max-w-[468px] md:p-10 ${className}`;
  const t6 = !!noMobilePadding;
  const t7 = !!noPadding;
  const t8 = !!wide;
  let t9;
  if ($[0] !== t5 || $[1] !== t6 || $[2] !== t7 || $[3] !== t8) {
    t9 = classNames(t5, {
      "p-0": t6,
      "p-0 md:p-0": t7,
      "md:max-w-[600px]": t8
    });
    $[0] = t5;
    $[1] = t6;
    $[2] = t7;
    $[3] = t8;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  let t10;
  if ($[5] !== children || $[6] !== t9) {
    t10 = <div className={t9}>{children}</div>;
    $[5] = children;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  return t10;
};
FrameContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  noMobilePadding: PropTypes.bool,
  noPadding: PropTypes.bool,
  wide: PropTypes.bool
};
export default FrameContainer;